"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdtfWriter = void 0;
const SdtfGrasshopperSdtfBuilder_1 = require("./builder/SdtfGrasshopperSdtfBuilder");
class SdtfWriter {
    constructor(factory) {
        this.factory = factory;
    }
    createSimpleDataSdtf(chunkName, data) {
        const mapAttributesData = (attr) => {
            const res = {};
            attr.forEach((data) => (res[data.name] = [data.content, data.typeHint]));
            return res;
        };
        const chunk = this.factory.createChunk(chunkName);
        data.forEach((d) => {
            const dataItem = this.factory.createDataItem(d.content, d.typeHint);
            if (d.attributes)
                dataItem.attributes = this.factory.createAttributes(mapAttributesData(d.attributes));
            chunk.items.push(dataItem);
        });
        const asset = this.factory.createAsset();
        asset.chunks.push(chunk);
        return asset;
    }
    createGrasshopperSdtfBuilder() {
        return new SdtfGrasshopperSdtfBuilder_1.SdtfGrasshopperSdtfBuilder(this.factory);
    }
}
exports.SdtfWriter = SdtfWriter;
//# sourceMappingURL=SdtfWriter.js.map